// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"b3502164","161":"8b031443","195":"9b6e5099","343":"93b7f453","505":"ff00c003","641":"0706da3f","754":"d670f5d9","848":"b3502164","911":"cf63b6a7"}[chunkId] + ".chunk.css";
};